export enum google_address_components {
    STREET_NUMBER = 'street_number',
    ROUTE = 'route',
    POSTAL_CODE = 'postal_code',
    LOCALITY = 'locality',
    STATE = 'administrative_area_level_1',
}